"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var config = {
  name: 'GCL',
  pluralName: 'GCL',
  featureFlag: 'gcl-enabled',
  visibility: 'private',
  owner: {
    gusTeam: 'MS Microgateway',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00AH000000in16YAA/view'
  },
  publication: {
    inferredBy: [{
      classifiers: ['gcl-bundle'],
      typeProperty: 'gcl'
    }],
    files: [{
      id: 'gcl',
      classifier: 'gcl-bundle',
      packaging: 'zip'
    }],
    minimumInputSets: [{
      files: ['gcl']
    }]
  }
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map